import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import QuestionPage from '@/views/QuestionPage.vue'
import ContactDetailsCapture from '@/views/ContactDetailsCapture.vue'
import ResultsPage from '@/views/ResultsPage.vue'
import ErrorView from '@/views/Error'
// import CallbackConfirmation from '@/views/CallbackConfirmation'
import ConfirmationPage from '@/views/ConfirmationPage'
import VersionPage from '@mic/frontend/views/VersionPage'
import revision from '@/revision.json'
import NotFoundPage from '@/views/NotFoundPage'
import {
  questionGuards,
  postQuestionGuards,
  indexGuards,
  utagView
} from './guards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: indexGuards
  },
  {
    path: '/question/:slug?',
    name: 'questionSlug',
    component: QuestionPage,
    beforeEnter: questionGuards
  },
  {
    path: '/results/',
    name: 'results',
    component: ResultsPage,
    beforeEnter: postQuestionGuards
  },
  {
    path: '/contact-details/',
    name: 'cdc',
    component: ContactDetailsCapture,
    beforeEnter: postQuestionGuards
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: ConfirmationPage,
    beforeEnter: postQuestionGuards
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorView
  },
  {
    path: '/version',
    name: 'version',
    component: VersionPage,
    props: {
      revision
    }
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFoundPage
  }
  ]
})

router.beforeEach((to, from, next) => {
  utagView(to, next)
})

export default router
